<template>
  <div>
    Copyrights © {{get_year}} Veo Worldwide Services
  </div>
</template>

<script>
export default {
  name: "Copyrights",
  computed: {
    get_year() {
      return (new Date()).getFullYear()
    },
  }
}
</script>
